import type { MonospaceApiKey } from '#layers/data-model/public';
import { defineRelations, withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';
import { User } from './user';

const API_KEY_DATETIME_FIELDS = ['issuedAt', 'expiresAt'] as const;

export const ApiKey = withItemType<MonospaceApiKey>().defineCollection({
	name: 'MonospaceApiKey',
	scopeId: MONOSPACE_SCOPE_ID,
	fields: defineSystemDateTimeFields(API_KEY_DATETIME_FIELDS),
	meta: {
		defaultFields: [
			'id',
			'userId',
			'name',
			'description',
			'active',
			'issuedAt',
			'expiresAt',
			'createdBy',
		],
		endpoint: 'system/api-keys',
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(API_KEY_DATETIME_FIELDS),
	},
});

export const ApiKeyRelations = defineRelations(ApiKey, ({ collection }) => ({
	user: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceApiKey.userId',
			},
		}),
	},
	creator: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceApiKey.createdBy',
			},
		}),
	},
}));
